import React, { useCallback } from "react";
import { fromExtent as polygonFromExtent } from "ol/geom/Polygon";
import Icon from "@avinet/adaptive-ui-core/ui/Icon";
import { useMapContext } from "../map/MapProvider";
/**
 * Add a ZoomToExtent button to the map.
 */
export default function ZoomToExtent({ title, text, extent, icon = "globe", }) {
    const { view } = useMapContext();
    const handleClick = useCallback(() => {
        var _a;
        const e = extent !== null && extent !== void 0 ? extent : (_a = view.getProjection()) === null || _a === void 0 ? void 0 : _a.getExtent();
        if (e)
            view.fitInternal(polygonFromExtent(e));
    }, [view, extent]);
    return (React.createElement("button", { type: "button", className: `btn map zoom-to-extent ${!text ? "icon" : ""}`, title: title, onClick: handleClick },
        React.createElement(Icon, { name: icon }),
        " ",
        text && React.createElement("span", null, text)));
}
